let activeLanguage = "tr";
const storageLng = window.localStorage.getItem('panelLanguage');
if (storageLng && ['en', 'tr'].indexOf(storageLng) > -1 && storageLng != activeLanguage) {
  activeLanguage = storageLng;
}

const dictionary = {
  tr: {
    'CLEANING': 'Temizlik',
    'REPAIRING': 'Bakım/Onarım',
    'FIXTURE': 'Demirbaş',
    'GROCERY': 'Market',
    'BILL': 'Aidat/Fatura',
    'LOAN': 'Kredilendirme',
    '[CREATE_API_KEY]::Invalid password': 'Kullanıcı adı veya şifre geçersiz',
    'Token is expired.': 'Oturum süresi doldu. Yeniden giriş yapınız',
    'Day_Sun': 'Paz',
    'Day_Mon': 'Pzt',
    'Day_Tue': 'Sal',
    'Day_Wed': 'Çrş',
    'Day_Thu': 'Prş',
    'Day_Fri': 'Cum',
    'Day_Sat': 'Cmt',
    'January': 'Ocak',
    'February': 'Şubat',
    'March': 'Mart',
    'April': 'Nisan',
    'May': 'Mayıs',
    'June': 'Haziran',
    'July': 'Temmuz',
    'August': 'Ağustos',
    'September': 'Eylül',
    'October': 'Ekim',
    'November': 'Kasım',
    'December': 'Aralık',
  },
  en: {
    'Temizlik Giderleri': 'Cleaning Expenses',
    'Diğer Giderler': 'Other Expenses',
    'Gösterilecek kayıt sayısı: _MENU_': 'Number of records to show: _MENU_',
    'Görevli Kişi': 'Responsible Person',
    'Masraf Tipi': 'Expense Type',
    'Masraf Tutarı': 'Expense Amount',
    'Ev': 'Property',
    'Güncelle': 'Update',
    '"_EMPLOYEE" tarafından yapılan __MAINTENANCECOST₺ tutarındaki onarım kaydını kalıcı olarak silmek istediğinize emin misiniz?': 'Are you sure you want to permanently delete the __MAINTENANCECOST₺ repair record made by "EMPLOYEE_"?',
    'Ay': 'Month',
    'Yıl': 'Year',
    'January': 'Ocak',
    'February': 'Şubat',
    'March': 'Mart',
    'April': 'Nisan',
    'May': 'Mayıs',
    'June': 'Haziran',
    'July': 'Temmuz',
    'August': 'Ağustos',
    'September': 'Eylül',
    'October': 'Ekim',
    'November': 'Kasım',
    'December': 'Aralık',
    'Edit Property Information': 'Edit Property Information',
    'Dashboard': 'Dashboard',
    'Yönetici': 'Administrator',
    'Tüm Hakları Saklıdır': 'All Rights Reserved',
    'Ana Sayfa': 'Home Page',
    'Kullanıcı Yönetimi': 'User Management',
    'Sistem Kullanıcıları': 'System Users',
    'Ev Sahipleri': 'Homeowners',
    'Ev Yönetimi': 'Property Management',
    'Gider Yönetimi': 'Expense Management',
    'Raporlar': 'Reports',
    'DODO Yönetim Paneli': 'DODO Management Panel',
    'Masraf Listesi': 'Expense List',
    'Rezervasyon görüntülemek için ev seçiniz': 'Select a Property to View Reservations',
    'Tüm Evler': 'All Properties',
    'Ev seçiniz': 'Select Property',
    'Filtrele': 'Filter',
    'Toplam Kazanç': 'Total Earnings',
    'Ev Sahiplerinin Kazancı': 'Homeowners Earnings',
    'DODO Kazanç': 'DODO Earnings',
    'Masraf Toplamı': 'Total Expenses',
    'Doluluk Oranı': 'Occupancy Rate',
    'Temizlik Sayısı': 'Number of Cleanings',
    'Gelir Grafiği': 'Revenue Graph',
    'Secilen tarih araliginda veri bulunamadi !': 'No Data Found for Selected Date Range!',
    'Apply': 'Apply',
    'Cancel': 'Cancel',
    'From': 'From',
    'To': 'To',
    'Custom': 'Custom',
    'Ağustos ayı': 'August',
    'Gelirler': 'Revenues',
    'Masraflar': 'Expenses',
    'Net Kazanç': 'Net Profit',
    'Temmuz': 'July',
    'Temmuz ayı': 'July',
    'Haziran ayı': 'June',
    'Mayıs ayı': 'May',
    'Detayları gizle': 'Hide Details',
    'Ad': 'First Name',
    'Soyad': 'Last Name',
    'Email': 'Email',
    'Cinsiyet': 'Gender',
    'Kullanıcı Durumu': 'User Status',
    'Yeni Kullanıcı Oluştur': 'Create New User',
    'İşlemler': 'Actions',
    'Dikkat!': 'Attention!',
    'Gösterilecek kayıt sayısı: _MENU_': 'Number of Records to show: _MENU_',
    'Gösterilecek veri bulunamadı': 'No Data Available',
    'Filtrelemeye göre eşleşen veri bulunamadı': 'No Matching Data Found for Filter',
    'Filtre: ': 'Filter: ',
    'İlk Sayfa': 'First Page',
    'Son Sayfa': 'Last Page',
    'Sonraki': 'Next',
    'Önceki': 'Previous',
    'Erkek': 'Male',
    'Aktif': 'Active',
    '_MAX_ kayıttan _START_ ile _END_ arasındaki görüntüleniyor': 'Displaying _START_ to _END_ of _MAX_ records',
    'En az 8 karakter': 'Minimum 8 Characters',
    'En az 1 büyük harf': 'At Least One Uppercase Letter',
    'En az 1 küçük harf': 'At Least One Lowercase Letter',
    'En az 1 rakam': 'At Least One Number',
    'En az 1 özel karakter': 'At Least One Special Character',
    'Sistem Kullanıcısını Düzenle': 'Edit System User',
    'Profil fotoğrafı': 'Profile Picture',
    'Dosya Seç': 'Select File',
    'Kaydet': 'Save',
    'Vazgeç': 'Cancel',
    '"_FULLNAME" Kullanıcısını kalıcı olarak silmek istediğinize emin misiniz?': 'Are you sure you want to permanently delete "FULLNAME_" user?',
    'Sil': 'Delete',
    'Yeni Sistem Kullanıcısı': 'New System User',
    'Şehir': 'City',
    'Kadın': 'Female',
    'Ev Sahibini Düzenle': 'Edit Homeowner',
    'Lütfen Şehir Seçiniz': 'Please Select a City',
    'Ev Listesi': 'Property List',
    'Ev İsmi': 'Property Name',
    'Ev Sahibi': 'Homeowner',
    'Durumu': 'Status',
    'Yeni Ev Oluştur': 'Create New Property',
    'Ev Bilgilerini Düzenle': 'Edit Property Information',
    'Lütfen Ev Sahibi Seçiniz': 'Please Select a Homeowner',
    'Rezervasyon Durumu': 'Reservation Status',
    'Komisyon Oranı': 'Commission Rate',
    'Airbnb ID': 'Airbnb ID',
    'Temizlik Kesintisi (₺)': 'Cleaning Deduction (₺)',
    'Açıklama': 'Description',
    'Adres': 'Address',
    'Evin fotoğrafları': 'Property Photos',
    'Temizlik Ücreti': 'Cleaning Fee',
    'Tanımlanmamış': 'Undefined',
    'Rezervasyonlar': 'Reservations',
    'Yeni Rezervasyon': 'New Reservation',
    'Misafir Adı': 'Guest Name',
    'Check In': 'Check In',
    'Check Out': 'Check Out',
    'Gece Sayısı': 'Number of Nights',
    'Günlük Kazanç': 'Daily Earnings',
    'Rezervasyon Değerlendirmeleri': 'Reservation Reviews',
    'Rezervasyon Değerlendirme Bilgileri': 'Reservation Review Information',
    'Masraf Açıklaması': 'Expense Description',
    'İşlemi Yapan Görevli': 'Responsible Staff',
    'Masraf tipi': 'Expense Type',
    'Masraf tutarı': 'Expense Amount',
    'Yapılış Tarihi': 'Date Incurred',
    'Masraf kayıtları': 'Expense Records',
    'Yeni Masraf Kaydı': 'New Expense Record',
    'Bakım/Onarım Kaydı Oluştur': 'Create Maintenance/Repair Record',
    'Masraf Detayları': 'Expense Details',
    'Eve ait fotoğraf bulunmamaktadır': 'No photos available for this property',
    'Düzenle': 'Edit',
    'Tarih': 'Date',
    'Dosyalar': 'Files',
    'Yeni Rezervasyon Bilgileri': 'New Reservation Information',
    'Temizlik tutarı (Otomatik olarak eksitilecektir): _CLEANINGFEE₺': 'Cleaning Fee (Will be Automatically Deducted): __CLEANINGFEE_₺',
    'Temizlik Ücreti (₺)': 'Cleaning Fee (₺)',
    'Günlük Temizlik Tutarı': 'Daily Cleaning Amount',
    'Rezervasyon Toplamı': 'Total Reservation',
    'Ev Sahibi Kazancı': 'Homeowner Earnings',
    'DODO Kazancı': 'DODO Earnings',
    'Kullanıcı Girişi': 'User Login',
    'E-mail adresi': 'E-mail Address',
    'Şifre': 'Password',
    'Giriş Yap': 'Login',
    'Şifremi Unuttum': 'Forgot Password',
    'Lütfen e-mail adresinizi giriniz': 'Please Enter Your E-mail Address',
    'Sistem Kullanıcıları Listesi': 'System Users List',
    'Kullanıcıyı Sil': 'Delete User',
    'Yeni Sistem Kullanıcısı Oluştur': 'Create New System User',
    'Şifre Oluştur': 'Create Password',
    'Şifre Güvenlik Durumu: ': 'Password Security Status: ',
    'Ev Sahipleri Listesi': 'Homeowners List',
    'Ev Sahibini Sil': 'Delete Homeowner',
    'Yeni Ev Sahibi Oluştur': 'Create New Homeowner',
    'Ev Sahibi Bilgilerini Düzenle': 'Edit Homeowner Information',
    'Ev Sahibi Açıklaması': 'Homeowner Description',
    'Ev Sil': 'Delete Property',
    'Evin Fotoğrafları': 'Property Photos',
    'Rezervasyonlar Listesi': 'Reservations List',
    'Rezervasyonu Sil': 'Delete Reservation',
    'Yeni Rezervasyon Oluştur': 'Create New Reservation',
    'Rezervasyon Bilgilerini Düzenle': 'Edit Reservation Information',
    'Misafir Bilgileri': 'Guest Information',
    'Önceki Rezervasyonlar': 'Previous Reservations',
    'Masraf Kayıtları Listesi': 'Expense Records List',
    'Masrafı Sil': 'Delete Expense',
    'Yeni Masraf Kaydı Oluştur': 'Create New Expense Record',
    'Masraf Bilgilerini Düzenle': 'Edit Expense Information',
    'CLEANING': 'Cleaning',
    'REPAIRING': 'Repairing',
    'FIXTURE': 'Fixture',
    'GROCERY': 'Grocery',
    'BILL': 'Dues/Bills',
    'LOAN': 'Loaning',
    '[CREATE_API_KEY]::Invalid password': 'Invalid username or password',
    'Token is expired.': 'Session is expired. Please login again',
    'Day_Sun': 'Sun',
    'Day_Mon': 'Mon',
    'Day_Tue': 'Tue',
    'Day_Wed': 'Wed',
    'Day_Thu': 'Thu',
    'Day_Fri': 'Fri',
    'Day_Sat': 'Sat',
    'Ocak': 'January',
    'Şubat': 'February',
    'Mart': 'March',
    'Nisan': 'April',
    'Mayıs': 'May',
    'Haziran': 'June',
    'Ağustos': 'August',
    'Eylül': 'September',
    'Ekim': 'October',
    'Kasım': 'November',
    'Aralık': 'December',
    'Ana Sayfa': 'Home',
    'Rezervasyon görüntülemek için ev seçiniz': 'Select a property to view reservations',
    'Ev Sahiplerinin Kazancı': 'Homeowners’ Earnings',
    'Gelir Grafiği': 'Earnings Chart',
    'Secilen tarih araliginda veri bulunamadi !': 'No data found for the selected date range!',
    'Net Kazanç': 'Net Earnings',
    'Dikkat!': 'Warning!',
    'Gösterilecek kayıt sayısı: _MENU_': 'Number of Records to show: _MENU_',
    'Gösterilecek veri bulunamadı': 'No data to display',
    'Filtrelemeye göre eşleşen veri bulunamadı': 'No data matched your filter',
    '__MAX__ kayıttan __START__ ile __END__ arasındaki görüntüleniyor': 'Displaying __START__ to __END__ of __MAX__ records',
    'En az 8 karakter': 'At least 8 characters',
    'En az 1 büyük harf': 'At least 1 uppercase letter',
    'En az 1 küçük harf': 'At least 1 lowercase letter',
    'En az 1 rakam': 'At least 1 digit',
    'En az 1 özel karakter': 'At least 1 special character',
    'Dosya Seç': 'Choose File',
    '"__FULLNAME__" Kullanıcısını kalıcı olarak silmek istediğinize emin misiniz?': 'Are you sure you want to permanently delete "__FULLNAME__" user?',
    'Temizlik Kesintisi (₺)': 'Cleaning Fee (₺)',
    'İşlemi Yapan Görevli': 'Staff Responsible',
    'Yapılış Tarihi': 'Date of Expense',
    'Temizlik tutarı (Otomatik olarak eksitilecektir): __CLEANINGFEE__₺': 'Cleaning fee (will be automatically deducted): __CLEANINGFEE__₺',
    '"__PROPERTYNAME__" Ev bilgilerini kalıcı olarak silmek istediğinize emin misiniz?': 'Are you sure you want to permanently delete "__PROPERTYNAME__" property information?',
    'Ev Adı': 'Property Name',
    'Geri Dön': 'Go Back',
    'Mülk Adı': 'Property Name',
    'Giriş Saati': 'Check-in Time',
    'Çıkış Saati': 'Check-out Time',
    'Temizlik Saati': 'Cleaning Time',
    'Günlük Fiyat': 'Daily Rate',
    'Misafir Sayısı': 'Number of Guests',
    'Yatak Sayısı': 'Number of Beds',
    'Yatak Odası Sayısı': 'Number of Bedrooms',
    'Banyo Sayısı': 'Number of Bathrooms',
    'Oda Sayısı': 'Number of Rooms',
    'M2': 'Sq. Meters',
    'Evin Adresi': 'Property Address',
    'Yeni Masraf Açıklaması': 'New Expense Description',
    'Lütfen Masraf Tipi Seçiniz': 'Please Select an Expense Type',
    'Kısa Bir Açıklama Giriniz': 'Please Enter a Short Description',
    'Kayıtlı Görevliler': 'Registered Staff',
    'Masrafı Yapan Görevliyi Seçiniz': 'Please Select the Staff Member Responsible for the Expense',
    'Toplam Tutar': 'Total Amount',
    'Masraf Tarihi': 'Expense Date',
    'Temizlik Kaydı': 'Cleaning Record',
    'Kırık Dökük Kaydı': 'Breakage Record',
    'Geri Bildirim Kaydı': 'Feedback Record',
    'Lütfen Rezervasyon Durumu Seçiniz': 'Please Select a Reservation Status',
    'Ev Düzenle': 'Edit Property',
    'Yeni Mülk Oluştur': 'Create New Property',
    'Yeni Mülk': 'New Property',
    'Görevli Ekle': 'Add Staff',
    'Görevli Bilgileri Düzenle': 'Edit Staff Information',
    'Görevli Adı': 'Staff Name',
    'Görevli Numarası': 'Staff Number',
    'Eve ait fotoğraf bulunmamaktadır.': 'No photos available for this property.',
    'Detayları Göster': 'Show Details',
    'Kategori': 'Category',
    'Alt Kategori': 'Subcategory',
    'Ürün': 'Product',
    'Hizmet': 'Service',
    'Tedarikçi': 'Supplier',
    'Tamamlanmış': 'Completed',
    'Beklemede': 'Pending',
    'Gönderilmemiş': 'Not Submitted',
    'Zamanlayıcı': 'Timer',
    'Şifre Güncelle': 'Update Password',
    'Son Güncelleme Tarihi': 'Last Update Date',
    'Ev Sahibinin Geliri': 'Homeowner\'s Income',
    'Ev Sahibinin Tutarı': 'Homeowner\'s Amount',
    'DODO Geliri': 'DODO Income',
    'Ev Sahibinin Temizlik Tutarı': 'Homeowner\'s Cleaning Fee',
    'Temizlik Tutarı': 'Cleaning Fee',
    'Sistem Dilini Seçiniz': 'Select System Language',
    'Çıkış Yap': 'Log Out',
    '__PROPERTYNAME__ Evinin masraflarını kalıcı olarak silmek istediğinize emin misiniz?': 'Are you sure you want to permanently delete the expenses of the __PROPERTYNAME__ property?',
    'Öncelikle masraf tipi seçmelisiniz!': 'First, you must select the type of expense!',
    'Temizlik Ücreti: __CLEANINGFEE__₺': 'Cleaning Fee: __CLEANINGFEE__₺',
    'Saat Dilimi': 'Time Zone',
    'Hesap Ayarları': 'Account Settings',
    'Mail Ayarları': 'Mail Settings',
    'SMS Ayarları': 'SMS Settings',
    'Kullanıcı Profili': 'User Profile',
    'Dil Seçenekleri': 'Language Options',
    'Türkçe': 'Turkish',
    'İngilizce': 'English',
    'API Ayarları': 'API Settings',
    'SMTP Sunucu Ayarları': 'SMTP Server Settings',
    'SMTP Sunucusu': 'SMTP Server',
    'SMTP Kullanıcı Adı': 'SMTP Username',
    'SMTP Şifre': 'SMTP Password',
    'Mail Gönderen Adı': 'Mail Sender Name',
    'Test Maili Gönder': 'Send Test Email',
    'SMS Sunucusu': 'SMS Server',
    'SMS Kullanıcı Adı': 'SMS Username',
    'SMS Şifre': 'SMS Password',
    'Test SMS Gönder': 'Send Test SMS',
    'Ev Sahibinin Temizlik Ücreti': 'Homeowner\'s Cleaning Fee',
    'Yeni Rezervasyon Bilgileri Oluştur': 'Create New Reservation Information',
    'Check in saati: __CHECKINTIME__': 'Check-in time: __CHECKINTIME__',
    'Check out saati: _CHECKOUTTIME__': 'Check-out time: __CHECKOUTTIME__',
    'Temizlik saati: _CLEANINGTIME__': 'Cleaning time: __CLEANINGTIME__',
    'Günlük fiyat: __DAILYRATE__': 'Daily rate: __DAILYRATE__',
    'Misafir sayısı: __NUMBEROFGUESTS__': 'Number of guests: __NUMBEROFGUESTS__',
    'Yatak sayısı: __NUMBEROFBEDS__': 'Number of beds: __NUMBEROFBEDS__',
    'Yatak odası sayısı': '__NUMBEROFBEDROOMS__',
    'Hata': 'Error',
  }
};
window.missingTranslations = window.missingTranslations || [];
const translate = function(str, replaceParams = null) {
  try {
    let translation = dictionary[activeLanguage][str];
    if (!translation) {
      window.missingTranslations.push(`"${activeLanguage}" translation is not found: "${str}"`);
      // console.error(`"${activeLanguage}" translation is not found: "${str}"`)
      translation = str;
    }
    if (replaceParams && Object.keys(replaceParams).length > 0) {
      Object.keys(replaceParams).forEach((paramName) => {
        translation = translation.replace(paramName, replaceParams[paramName]);
      })
    }
    return translation;
  } catch(err) {
    console.error(err)
  }
  return str;
};

export default translate;
